export const SHARED_WITH_ME = 'shared_with_me',
  SHARED_BY_ME = 'shared_by_me';